module.exports = "https://www.gc-pro.gnp.com.mx/314561389b2208026df7d457d9bff320.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_close.png
// module id = 690
// module chunks = 0